__turbopack_context__.v({
  "imageFooter": "public-vote-module-scss-module__lgbM5G__imageFooter",
  "logo": "public-vote-module-scss-module__lgbM5G__logo",
  "responsiveButton": "public-vote-module-scss-module__lgbM5G__responsiveButton",
  "votingBox": "public-vote-module-scss-module__lgbM5G__votingBox",
});
